import React, { useState } from "react";
import { useI18n } from "../../i18n/I18nContext";
import { api, apiError } from "../../lib/api";
import { toast } from "sonner";

export default function Contact() {
  const { t, isAr } = useI18n();
  const [f, setF] = useState({ name: "", phone: "", message: "" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", f); setSent(true); toast.success(isAr ? "تم الإرسال" : "Sent"); }
    catch (er) { toast.error(apiError(er)); }
  };
  return (
    <div className="mx-auto max-w-lg px-4 py-12 sm:px-8">
      <h1 className="text-3xl font-bold text-slate-900 sm:text-4xl">{t("nav.contact")}</h1>
      {sent ? <p className="mt-8 rounded-xl bg-green-50 p-6 text-center text-green-700">{isAr ? "شكراً لتواصلك، سنرد قريباً" : "Thanks, we'll reply soon"}</p> : (
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input required placeholder={t("common.name")} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="contact-name" className="w-full rounded-xl border border-border px-4 py-3" />
          <input required placeholder={t("common.phone")} dir="ltr" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="contact-phone" className="w-full rounded-xl border border-border px-4 py-3" />
          <textarea required rows={4} placeholder={isAr ? "رسالتك" : "Your message"} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} data-testid="contact-message" className="w-full rounded-xl border border-border px-4 py-3" />
          <button type="submit" data-testid="contact-submit" className="w-full rounded-full bg-primary py-3 font-semibold text-white hover:bg-primary/90">{isAr ? "إرسال" : "Send"}</button>
        </form>
      )}
    </div>
  );
}
